module.exports = __webpack_public_path__ + "static/media/Img_2.66dbbd05.JPG";